import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.7086 9.2914C9.6981 9.77405 9 10.8055 9 12C9 13.6568 10.3431 15 12 15C13.1945 15 14.2259 14.3019 14.7086 13.2914",
      stroke: "#6841EA",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.1397 5.86035C13.4696 5.6269 12.7496 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5898 8.41015 18.5 12 18.5C15.5898 18.5 18.5 15.5898 18.5 12C18.5 11.2504 18.3731 10.5304 18.1397 9.86035",
      stroke: "#6841EA",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16.7838 3.21627C15.3628 2.44075 13.7329 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22C17.5229 22 22 17.5229 22 12C22 10.2672 21.5593 8.63725 20.7838 7.21625",
      stroke: "#6841EA",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 2L12 12",
      stroke: "#6841EA",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }